const KEY = "lldls_last_submit";

export const canSubmitNow = () => {
  const last = Number(localStorage.getItem(KEY) || 0);
  return Date.now() - last > 60000;
};

export const markSubmitted = () => {
  localStorage.setItem(KEY, String(Date.now()));
};
